module.exports = __webpack_public_path__ + "img/shadow-copyings.bf202b22.svg";